// removed by extract-text-webpack-plugin
module.exports = {"light-grey":"#d4d4d4","background-grey":"#f6f6f6","black":"#000000","fastest":".15s","linear":"cubic-bezier(0, 0, 1, 1)","tab":"EOD1z5CTsRe5DBJwaBypO","active":"_39JocWxYCVqDE0trHkURSz"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tabs/TabsSection/Tabs/Tab/Tab.css
// module id = 1150
// module chunks = 0